import request from '@/util/request'

// For each key in EXPERIMENTS, check REGISTERED_EXPERIMENTS to ensure the key is present.
// If it isn't, choose a segment from the segments object in the experiment at random based upon the percentage values of all of the segments.
// In this same routine, removed any keys from REGISTERED_EXPERIMENTS that are not in AVAILABLE_EXPERIMENTS
function registerDeregisterExperiments(experiments, registeredExperiments) {
  for (const experimentId of Object.keys(experiments)) {
    if (!registeredExperiments[experimentId] || registeredExperiments[experimentId].version !== experiments[experimentId].version) { // This experiment is not registered or new version is available.
      const segments = experiments[experimentId].segments
      const segmentIds = Object.keys(segments)
      const segmentPercentages = segmentIds.map(segmentId => segments[segmentId].percentage)
      registeredExperiments[experimentId] = {version: experiments[experimentId].version, segment: segmentIds[Math.floor(Math.random() * 100) < segmentPercentages[0] ? 0 : 1]}
    }
  }
  // Now check for removed experiments
  for (const experimentId in registeredExperiments) {
    if (!experiments[experimentId]) {
      registeredExperiments[experimentId] = undefined
    }
  }
  return registeredExperiments
}

function extractSegments(inputObj) {
  const result = {};
  for (const key in inputObj) {
    if (inputObj[key]?.segment) {
      result[key] = inputObj[key].segment;
    }
  }
  return result;
}

const state = {
  REGISTERED_EXPERIMENTS: {},
  EXPERIMENTS: {}
}

const getters = {
  getExperiments: (state) => state.EXPERIMENTS,
  getRegisteredExperiments: (state) => {
    if (JSON.stringify(state.REGISTERED_EXPERIMENTS).indexOf(`version`) === -1) return state.REGISTERED_EXPERIMENTS
    return extractSegments(state.REGISTERED_EXPERIMENTS)
  }
}

const actions = {
  async logInteraction({commit, getters, dispatch}, data) {
    return request({
      url: '/experiments',
      data,
      method: 'post',
    })
  },
  resetExperiments({commit}) {
    commit('SET_REGISTERED_EXPERIMENTS', {})
  }
}

const mutations = {
  SET_EXPERIMENTS(state, payload) {
    state.EXPERIMENTS = payload
    this.commit(`SET_REGISTERED_EXPERIMENTS`, payload)
  },
  SET_REGISTERED_EXPERIMENTS(state, payload) {
    state.REGISTERED_EXPERIMENTS = registerDeregisterExperiments(payload, state.REGISTERED_EXPERIMENTS)
  }
}

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations,
}
